import React, {Component} from "react";

import "./not-found.scss";

import {Container, Header, Segment} from "semantic-ui-react";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import logo from "../../../assets/images/kt_logo_default.svg";
import {Title} from "../title/title";

export class Notfound extends Component {
    render(): React.ReactElement {
        return (
            <Container className="not-found">
                <Header>
                    <span className={"header__logo"}><SVG src={logo} height={27} width={84}/></span>
                    <span className={"header__label-name"}>Geoportal</span>
                </Header>
                <Segment>
                    <>
                        <Title siteTitle={"Anwendung nicht gefunden"} />
                        <Header as="h2">Anwendung nicht gefunden</Header>
                        <p>
                            Die gesuchte Anwendung konnte leider nicht gefunden werden.&nbsp;<br/><br/>
                            Dies kann unterschiedliche Ursachen haben:
                        </p>
                        <ul>
                            <li>Die Anwendung wurde unter einer falschen Adresse aufgerufen.</li>
                            <li>Die Anwendung steht kurzzeitig nicht zur Verfügung.</li>
                            <li>Die Anwendung wurde verschoben oder gelöscht.</li>
                        </ul>
                        <p>Folgende Schritte können Sie durchführen:</p>
                        <ul>
                            <li>Überprüfen Sie die korrekte Schreibweise der Webadresse.</li>
                            <li>Verwenden Sie die Navigation oder die Suche im <Link to="https://geoportal.lu.ch/">
                                <span className="linked">Kantonalen Geoportal</span>
                            </Link> um zum gewünschten Angebot zu gelangen.
                            </li>
                        </ul>
                        <p>Sollten Sie damit keinen Erfolg erzielen, <Link to="mailto:geo@lu.ch">
                            <span className="linked">kontaktieren Sie uns</span>
                            </Link> mit Angabe der gesuchten Anwendung und des verwendeten Browsers.
                        </p>
                        <p>
                            Vielen Dank für Ihre Unterstützung.<br/>
                            Geoinformation Kanton Luzern
                        </p>
                    </>
                </Segment>
            </Container>
        );
    }
}
